import { AeoPromptTopicSchema } from "@redotech/redo-model/aeo/prompt";
import * as z from "zod";

export const AeoPromptSchema = z.object({
  id: z.bigint(),
  prompt: z.string(),
  branded: z.boolean(),
  topics: z.array(AeoPromptTopicSchema),
  createdAt: z.string(),
  deletedAt: z.string().nullable(),
  shareOfVoice: z.number().nullable(),
  brandMentions: z.number().nullable(),
});
export type AeoPrompt = z.infer<typeof AeoPromptSchema>;
